<script setup>
import PLinearProgress from '@/components/ProxifyUI/PLinearProgress.vue';

defineProps({
  size: {
    type: String,
    default: '4px',
  },
  rounded: {
    type: Boolean,
    default: true,
  },
  value: {
    type: Number,
    default: 0,
  },
});
</script>

<template>
  <PLinearProgress
    :size="size"
    :rounded="rounded"
    :value="value"
    class="text-proxify-primary-600 bg-proxify-gray-200"
  />
</template>
